import React from "react";
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
} from "@mui/material";
import { useField, useFormikContext, ErrorMessage } from "formik";

const CheckboxWrapper = ({
  name,
  label,
  legend,
  checked,
  icon,
  checkedIcon,
  onClick,
  ...otherProps
}) => {
  const { setFieldValue } = useFormikContext();
  const [field, meta] = useField(name);
  const handleChange = (evt) => {
    const { checkedValue } = evt.target;
    setFieldValue(name, checkedValue);
  };

  const configCheckbox = {
    ...field,
    ...otherProps,
    icon,
    checkedIcon,
    onChange: handleChange,
  };

  const configFormControl = {};
  if (meta && meta.touched && meta.error) {
    configFormControl.error = true;
    configFormControl.helperText = meta.error;
  }

  return (
    <FormControl {...configFormControl}>
      <FormLabel component="legend">{legend}</FormLabel>
      <FormGroup>
        <FormControlLabel
          control={<Checkbox {...configCheckbox} />}
          label={label}
          checked={checked}
          onClick={onClick}
        />
        <ErrorMessage name={name}>
          {(msg) => <div style={{ color: "#d32f2f" }}>{msg}</div>}
        </ErrorMessage>
      </FormGroup>
    </FormControl>
  );
};

export default CheckboxWrapper;
